import Axios from "axios";

class AuthDataService {
  forgot(obj) {
    return Axios.post("auth/forgot", obj);
  }

  recoveryPassword(obj) {
    return Axios.post("auth/recovery_password", obj);
  }

  refreshToken() {
    return Axios.post("auth/refresh_token");
  }
}

export default new AuthDataService();
